export const chartHeight = 160;